import Main from './Main'
import Create from './Create'
import Application from './Application'
import Billings from './Billings'

export default {
  Main,
  Create,
  Application,
  Billings
}



// WEBPACK FOOTER //
// ./src/components/Community/Main/index.js